import { createUseStyles, withTheme } from '@glu/theming';
import PropTypes from 'prop-types';
import React from 'react';
import locale from '@glu/locale';
import { AccessibilityText } from '@glu/utilities-react';
import styles from './WeekDays.styles';

const useStyles = createUseStyles(styles);

const WeekDays = ({ weekNumbers, ...rest }) => {
  const classes = useStyles(rest);

  const weekdays = [
    { label: locale.get('sun'), screenReaderLabel: locale.get('sunday') },
    { label: locale.get('mon'), screenReaderLabel: locale.get('monday') },
    { label: locale.get('tue'), screenReaderLabel: locale.get('tuesday') },
    { label: locale.get('wed'), screenReaderLabel: locale.get('wednesday') },
    { label: locale.get('thu'), screenReaderLabel: locale.get('thursday') },
    { label: locale.get('fri'), screenReaderLabel: locale.get('friday') },
    { label: locale.get('sat'), screenReaderLabel: locale.get('saturday') },
  ];
  return (
    <thead>
      <tr>
        {weekNumbers && (
          <th className={`${classes.headerCell} ${classes.weekHeader}`}>
            <span aria-hidden>{locale.get('weekHeader')}</span>
            <AccessibilityText>{locale.get('weekHeaderNumber')}</AccessibilityText>
          </th>
        )}
        {weekdays.map((day, i) => (
          <th key={`day-${i + 1}-${day.label}`} className={classes.headerCell}>
            <span aria-hidden>{day.label}</span>
            <AccessibilityText>{day.screenReaderLabel}</AccessibilityText>
          </th>
        ))}
      </tr>
    </thead>
  );
};

WeekDays.propTypes = {
  weekNumbers: PropTypes.bool.isRequired,
};

export default withTheme(WeekDays);
